import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';

import { BrandThemesEnum } from '../../_enums/themes.enum';
import { ThemesTextEnum } from '../../_enums/themes-text.enum';

@Component({
  selector: 'sd-title',
  templateUrl: './title.component.html',
  styleUrl: './title.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgTemplateOutlet]
})
export class SdTitleComponent {
  customClass = input<string>();

  /**
   * Allow to define the level of the title tag (h1 - h6).
   * * @param {number} 1 to 6, default 4
   */
  titleLevel = input<number>(4);

  /**
   * Allow to define the theme for the title is dark (default), light or "branded"
   * * @param {string} dark | light | brand
   */
  titleThemesConfig = input<BrandThemesEnum.brand | ThemesTextEnum>();

  /**
   * Determines whether the text is inside a hx tag or in a p tag
   */
  isDescription = input(false);

  globalClass = computed(() => {
    const newClass = this.customClass() || '';
    const theme = this.titleThemesConfig();

    return newClass + (theme ? ' is-text-' + theme : '');
  });
}
